import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["colspan"]
const _hoisted_2 = {
  key: 0,
  class: "jumbotron"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-meh-o" }, null, -1 /* HOISTED */)
const _hoisted_4 = {
  key: 1,
  class: "container mt-3 text-center"
}
const _hoisted_5 = { class: "lead" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", {
      class: "text-align-center",
      colspan: _ctx.colSpan
    }, [
      (!_ctx.component)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h4", null, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.primaryMessage ? _ctx.primaryMessage : "No Data Found."), 1 /* TEXT */)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.component)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.secondaryMessage ? _ctx.secondaryMessage : "Try refining your search criteria."), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ], 8 /* PROPS */, _hoisted_1)
  ]))
}